<template>
    <Layout :content-class="'content--centered'">
        <div class="not-found">
            <h1 class="not-found__header">404</h1>
            <p class="not-found__descr">Oops! Page not found</p>
            <RouterLink to="/">Back to books</RouterLink>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'NotFoundPage',
    components: {
        Layout
    }
};
</script>

<style lang="scss" src="./NotFoundPage.scss"></style>
